import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ClBaseComponent } from '../cl-base/cl-base.component';
import { Resource } from 'src/app/components/catalogs/beamline-catalog/resource/resources';
import { ResourceType } from 'src/app/common/enumerations/enumerations';

@Component({
  selector: 'cl-brc-forms',
  templateUrl: './cl-brc-forms.component.html',
  styleUrls: ['./cl-brc-forms.component.scss']
})
export class ClBrcFormsComponent extends ClBaseComponent implements OnInit, OnDestroy {

  @Input() resourceID?: number;

  private resourcesSubs?: Subscription;
  private keRestricted = false;
  private beamlineName = '';
  override suggested = false;

  override get labelHtml(): string {
    return 'Review any related open <b class="blue">BRC Forms</b> to verify that key-enable may proceed.';
  }

  ngOnInit(): void {
    if (!this.editor && !this.builder) {
      this.loadResources();
    }
  }

  override ngOnDestroy(): void {
    this.resourcesSubs?.unsubscribe();
    super.ngOnDestroy();
  }

  /**
   * Explains why an unrestricted beamline recommends a manual BRC Forms signature.
   */
  get suggestionTooltip(): string {
    return `No BRC Forms restrict key-enable for ${this.beamlineName || 'this beamline'}. Review the result and sign this task manually.`;
  }

  /**
   * Signs or unsigns the task from a user click, keeping the recommendation when unchecked and unrestricted.
   * @param e Checkbox change event.
   */
  checkboxChanged(e: any) {
    this.checked = e.checked;
    this.user = this.checked ? this.getCurrentUser(true) : null;
    this.suggested = !this.checked && !this.keRestricted;
    this.answered.emit(this.checked);
  }

  /**
   * Reads the beamline KE restriction and recommends a manual signature; it never signs the task automatically.
   * A restricted beamline still removes an existing signature, as before.
   */
  loadResources() {
    this.resourcesSubs?.unsubscribe();
    this.resourcesSubs = this.store.select(state => state.Resources.data).subscribe((data: Resource[]) => {
      if (!data.length || !this.resourceID) return;

      const resource = data.find(r => r.id === this.resourceID);
      // The Resources store fills `type`; `resourceTypeID` is only present on some catalog payloads.
      const resourceType = resource?.resourceTypeID ?? resource?.type;
      let beamline: Resource | undefined;

      if (resourceType === ResourceType.Shutter) {
        const beamlineId = resource?.childResources?.find(cr => cr.childResourceType === ResourceType.Beamline)?.childResourceID;
        beamline = data.find(r => r.id === beamlineId);
      } else if (resourceType === ResourceType.Beamline) {
        beamline = resource;
      }

      if (beamline === undefined) return;

      this.keRestricted = !!beamline.keRestricted;
      this.beamlineName = beamline.name?.trim() ?? '';
      // An unrestricted beamline is a recommendation for the operator, not an automatic signature.
      this.suggested = !this.keRestricted && !this.checked;

      if (this.keRestricted) {
        this.disabled = true;
        if (this.checked) {
          this.checked = false;
          this.answered.emit(false);
        }
      }
    });
  }
}
